// extracted by mini-css-extract-plugin
export default {"inputBox":"z3p6d1FKUYhOvvpCUiNs"};